import Project from './Project';

export default function Projects() {
  return (
    <section className="border-t border-surface-border px-5 py-14 sm:px-12 sm:py-20">
      <h2 className="text-3xl font-bold mb-2 sm:text-4xl sm:mb-3">
        <span className="text-gradient">Projects</span>
      </h2>
      <p className="text-gray-400 mb-8 sm:mb-10 text-sm sm:text-base">Selected work</p>
      <div className="space-y-6 sm:space-y-8">
        <Project
          title="AI Chatbot Dashboard"
          period="Nov 2025 — Jan 2026"
          stack="Java • Spring Boot • Hibernate/JPA • MongoDB • Docker • GitHub Actions"
          highlights={[
            "Designed a layered Spring Boot backend following clean architecture using DTOs and Hibernate ORM.",
            "Developed RESTful APIs for AI conversation management and backend orchestration.",
            "Containerized with Docker and automated CI/CD using GitHub Actions.",
            "Applied object-oriented design principles to build scalable backend services.",
          ]}
        />
        <Project
          title="InstaChat — Full-Stack Social Media Platform"
          period="May 2024 — Dec 2024"
          stack="React.js • Node.js • Express.js • PostgreSQL • Passport.js • Docker"
          highlights={[
            "Built a full-stack social platform using React.js, Express.js and PostgreSQL.",
            "Designed and implemented 15+ RESTful APIs supporting authentication, messaging and social features.",
            "Implemented JWT authentication, Passport.js and role-based authorization.",
            "Dockerized the application using Docker Compose for consistent deployments.",
          ]}
          gitLink="https://github.com/ReturnofMatrix/messagingApp"
        />
      </div>
    </section>
  );
}
